import { FileError } from "react-dropzone";
export interface FormModel {
    schoolorg: string;
    contactperson: string;
    phonenumberschoolorg: string;
    mailadress: string;
    journey: string; 
    returnJourney: string; 
    traveltype: string;
    SeatAvailabilityDisclaimer?: boolean;
    SelfResponsibility?: boolean;
    gdprAccept?: boolean;

    selectedJourney: {
        fromName: string;
        toName: string;
        date: string;
        travelTime: string;
        journeyKey: string;
        line: string;
        switches: string;
        unformattedDate: string;
    };
    selectedReturnJourney: {
        fromName: string;
        toName: string;
        date: string;
        travelTime: string;
        journeyKey: string;
        line: string;
        switches: string;
        unformattedDate: string;
    };
    
    //Test components:
    testpicker: string;
    filesuploadtest: UploadableFile[];
    textareatest: string;
    inputtest: string;
    radiotest: string;

    travelQty: string;
    phonenumber: string;
    
}


export interface UploadableFile {
    id: number;
    file: File;
    data: string;
    size: number;
    errors: FileError[];
}

export enum TimePeriod {
    Year,
    Month,
    Week,
    Day,
    Hour,
    Minute,
    Second,
    MilliSecond,
}

interface SelectedJourney {
    fromName: string;
    toName: string;
    date: string;
    travelTime: string;
    journeyKey: string;
    line: string;
    switches: string;
    unformattedDate: string,
}

interface Stop {
    PlaceName: string;
    OgtType: string;
    Ll: [number, number];
    Id: number;
}

export interface TravelSearchModel {
    selectedJourneyFrom: Stop | null;
    selectedJourneyTo: Stop | null;
    journeyDate: string;
    journeyTime: string;
}

export interface TravelReturnSearchModel {
    selectedReturnJourneyFrom: Stop | null;
    selectedReturnJourneyTo: Stop | null;
    returnJourneyDate: string;
    returnJourneyTime: string;
}